import React, { memo, useEffect, useState } from 'react'

import { ASSET_TYPE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import useBreakpoint from 'Utils/useBreakpoint'

import AssetTypeToggle from './Components/AssetTypeToggle/AssetTypeToggle'
import DatePublished from './Components/DatePublished/DatePublished'
import Designers from './Components/Designers/Designers'
import FileFormat from './Components/FileFormat/FileFormat'
import License from './Components/License/License'
import MoreFilters from './Components/MoreFilters/MoreFilters'
import Price from './Components/Price/Price'
import Quality from './Components/Quality/Quality'
import ResetButton from './Components/ResetButton/ResetButton'
import Sorting from './Components/Sorting/Sorting'

function MainFilters() {
  const assetType = useSearchPageStore(state => state.assetType)
  const breakpoint = useBreakpoint()
  // Gate breakpoint-dependent layout until mounted so the first client render matches SSR
  // (useBreakpoint is undefined on the server), avoiding a hydration mismatch.
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])

  // At sm the contextual (secondary) filters take over the second row, so Sorting moves up
  // next to Filters and the quick-sort chips are hidden. xs always keeps the standard
  // two-row layout (chips + Sorting), regardless of the selected asset type.
  const sortingInPrimary = hasMounted
    && breakpoint === 'sm'
    && assetType !== ASSET_TYPE.ALL

  return (
    <div className="search-page__main-filters">
      <div className="main-filters__primary">
        <AssetTypeToggle />
        <div className="main-filters__slot main-filters__slot--md">
          <FileFormat />
        </div>
        <div className="main-filters__slot main-filters__slot--lg">
          <Quality />
        </div>
        <div className="main-filters__slot main-filters__slot--lg">
          <Price />
        </div>
        <div className="main-filters__slot main-filters__slot--xxl">
          <DatePublished />
        </div>
        <div className="main-filters__slot main-filters__slot--xxl">
          <Designers />
        </div>
        <div className="main-filters__slot main-filters__slot--lg">
          <License />
        </div>
        <MoreFilters />
        {sortingInPrimary && <Sorting showChips={false} />}
      </div>
      {!sortingInPrimary && (
        <div className="main-filters__secondary">
          <Sorting />
          <ResetButton />
        </div>
      )}
    </div>
  )
}

export default memo(MainFilters)
